(function () {
  'use strict';
  angular
    .module('sempraWebapp')
    .filter('karcherPointTranslation', karcherPointTranslation);
  /** @ngInject */
  function karcherPointTranslation($translate) {
    return function (text) {
      if (!text) return;
      switch (text) {
        case 'Hol':
          return $translate.instant('KARCHER_POINT_NAME_1');
        case 'Mon':
          return $translate.instant('KARCHER_POINT_NAME_2');
        case 'Tue':
          return $translate.instant('KARCHER_POINT_NAME_3');
        case 'Wed':
          return $translate.instant('KARCHER_POINT_NAME_4');
        case 'Thu':
          return $translate.instant('KARCHER_POINT_NAME_5');
        case 'Fri':
          return $translate.instant('KARCHER_POINT_NAME_6');
        case 'Sat':
          return $translate.instant('KARCHER_POINT_NAME_7');
        case 'Sun':
          return $translate.instant('KARCHER_POINT_NAME_8');
        case 'VacuumsHol':
          return $translate.instant('KARCHER_POINT_NAME_9');
        case 'VacuumsMon':
          return $translate.instant('KARCHER_POINT_NAME_10');
        case 'VacuumsTue':
          return $translate.instant('KARCHER_POINT_NAME_11');
        case 'VacuumsWed':
          return $translate.instant('KARCHER_POINT_NAME_12');
        case 'VacuumsThu':
          return $translate.instant('KARCHER_POINT_NAME_13');
        case 'VacuumsFri':
          return $translate.instant('KARCHER_POINT_NAME_14');
        case 'VacuumsSat':
          return $translate.instant('KARCHER_POINT_NAME_15');
        case 'VacuumsSun':
          return $translate.instant('KARCHER_POINT_NAME_16');
        case 'IlluminationHol':
          return $translate.instant('KARCHER_POINT_NAME_17');
        case 'IlluminationMon':
          return $translate.instant('KARCHER_POINT_NAME_18');
        case 'IlluminationTue':
          return $translate.instant('KARCHER_POINT_NAME_19');
        case 'IlluminationWed':
          return $translate.instant('KARCHER_POINT_NAME_20');
        case 'IlluminationThu':
          return $translate.instant('KARCHER_POINT_NAME_21');
        case 'IlluminationFri':
          return $translate.instant('KARCHER_POINT_NAME_22');
        case 'IlluminationSat':
          return $translate.instant('KARCHER_POINT_NAME_23');
        case 'IlluminationSun':
          return $translate.instant('KARCHER_POINT_NAME_24');
        case 'Program_0':
          return $translate.instant('KARCHER_POINT_NAME_25');
        case 'Program_1':
          return $translate.instant('KARCHER_POINT_NAME_26');
        case 'Program_2':
          return $translate.instant('KARCHER_POINT_NAME_27');
        case 'Program_3':
          return $translate.instant('KARCHER_POINT_NAME_28');
        case 'Program_4':
          return $translate.instant('KARCHER_POINT_NAME_29');
        case 'Program_5':
          return $translate.instant('KARCHER_POINT_NAME_30');
        case 'Program_6':
          return $translate.instant('KARCHER_POINT_NAME_31');
        case 'Program_7':
          return $translate.instant('KARCHER_POINT_NAME_32');
        case 'Program_8':
          return $translate.instant('KARCHER_POINT_NAME_33');
        case 'Program_9':
          return $translate.instant('KARCHER_POINT_NAME_34');
        case 'Program_10':
          return $translate.instant('KARCHER_POINT_NAME_35');
        case 'Program_11':
          return $translate.instant('KARCHER_POINT_NAME_36');
        case 'Program_12':
          return $translate.instant('KARCHER_POINT_NAME_37');
        case 'Program_13':
          return $translate.instant('KARCHER_POINT_NAME_38');
        case 'Program_14':
          return $translate.instant('KARCHER_POINT_NAME_39');
        case 'Program_15':
          return $translate.instant('KARCHER_POINT_NAME_40');
        case 'Program_16':
          return $translate.instant('KARCHER_POINT_NAME_41');
        case 'Program_17':
          return $translate.instant('KARCHER_POINT_NAME_42');
        case 'Program_18':
          return $translate.instant('KARCHER_POINT_NAME_43');
        case 'Program_19':
          return $translate.instant('KARCHER_POINT_NAME_44');
        case 'Program_20':
          return $translate.instant('KARCHER_POINT_NAME_45');
        case 'Program_21':
          return $translate.instant('KARCHER_POINT_NAME_46');
        case 'Program_22':
          return $translate.instant('KARCHER_POINT_NAME_47');
        case 'Program_23':
          return $translate.instant('KARCHER_POINT_NAME_48');
        case 'Program_24':
          return $translate.instant('KARCHER_POINT_NAME_49');
        case 'Program_25':
          return $translate.instant('KARCHER_POINT_NAME_50');
        case 'Program_26':
          return $translate.instant('KARCHER_POINT_NAME_51');
        case 'Program_27':
          return $translate.instant('KARCHER_POINT_NAME_52');
        case 'Program_28':
          return $translate.instant('KARCHER_POINT_NAME_53');
        case 'Program_29':
          return $translate.instant('KARCHER_POINT_NAME_54');
        case 'Program_30':
          return $translate.instant('KARCHER_POINT_NAME_55');
        case 'Program_31':
          return $translate.instant('KARCHER_POINT_NAME_56');
        case 'Program_32':
          return $translate.instant('KARCHER_POINT_NAME_57');
        default:
          return $translate.instant(text);
      }
    };
  }
})();
